import React from "react";
import Franchise from "./sections/Franchise";
import SocialMedia from "./sections/SocialMedia";
import Categories from "./sections/Categories";
import DeliveryAreas from "./sections/DeliveryAreas";
import Links from "./sections/Links";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";

const NewFooter = () => {
    const { isDesktop } = useViewport();
    if (isDesktop) {
        return (
            <div className="footer-container">
                <div className="container">
                    <Franchise />
                    <div className="footer_inline_container">
                        <SocialMedia />
                        <Categories />
                    </div>
                    <div className="footer_inline_container">
                        <DeliveryAreas />
                    </div>
                    <Links />
                </div>
            </div>
        );
    }

    return (
        <div className="footer-container">
            <div className="container">
                <Franchise />
                <SocialMedia />
                <Categories />
                <DeliveryAreas />
                <Links />
            </div>
        </div>
    );
};

export default NewFooter;
